'use strict';

var React = require('react');

var SvgColorIcon = function SvgColorIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5 3a.75.75 0 0 0 0 1.5h2.69l-5.013 5.012a1.75 1.75 0 0 0 0 2.475l4.086 4.086a1.75 1.75 0 0 0 2.474 0l6.543-6.543a.75.75 0 0 0 0-1.06l-4.793-4.793-.013-.014-.444-.443a.75.75 0 0 0-.53-.22h-5Zm4.921 1.732.799.798.009.01 3.46 3.46-1.69 1.69-1.865-1.867a1.25 1.25 0 0 0-1.768 0l-1.293 1.293a1.25 1.25 0 0 0 0 1.768l1.866 1.866-1.262 1.262a.25.25 0 0 1-.354 0l-4.086-4.085a.25.25 0 0 1 0-.354l5.836-5.836a.25.25 0 0 1 .348-.005Zm.579 7.957.94-.94-1.69-1.688-.94.939 1.69 1.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 15a1.5 1.5 0 1 1-3 0c0-.53.614-2.122 1.057-3.2a.476.476 0 0 1 .886 0c.443 1.078 1.057 2.67 1.057 3.2Z"
  }));
};
SvgColorIcon.displayName = "ColorIcon";

exports.SvgColorIcon = SvgColorIcon;
